module.exports = __webpack_public_path__ + "static/media/focus-productivity-procrastination@2x.05abe764.png";